import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { errorMessages, OapErrorMessages, OapStandarErrorStateMatcher, regExps } from 'src/app/modules/custom-validators/custom-validators.module';
import { AlertService } from 'src/app/services/alert.service';
import { MessageService } from 'src/app/services/message.service';
import { SupportSujet, SupportSujetRequest, SupportSujetUpdateRequest } from '../../support-sujet-model';
import { SupportSujetService } from '../../support-sujet-service.service';

@Component({
  selector: 'oap-support-sujet-detail',
  templateUrl: './support-sujet-detail.component.html',
  styleUrls: ['./support-sujet-detail.component.scss']
})
export class SupportSujetDetailComponent implements OnInit {

  supportSujetForm: FormGroup;
  submitted = false;

  matcher = new OapStandarErrorStateMatcher();
  errors = errorMessages;
  validation_messages = OapErrorMessages;

  current: SupportSujet;

  supportSujetRequested: string;
  supportSujetPublique: boolean;
  typeSupportSujet: string;

  editMode = false;

  title: string = 'Ajout sujet';

  informations: string;

  linkBack: string;

  constructor(private messageService: MessageService,
    private supportSujetService : SupportSujetService,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private _router: Router,
    private _route: ActivatedRoute) { }

  ngOnInit() {
    this.supportSujetRequested = this._route.snapshot.paramMap.get('key');

    this._route.queryParams.subscribe(params => {
      console.info(' detail params : ' + params);
      this.typeSupportSujet = params['typeSupportSujet'];
      this.supportSujetPublique = this.typeSupportSujet === 'connected' ? false : true;
      console.info('supportSujetPublique : ' + this.supportSujetPublique);

      if(this.supportSujetPublique) {
        this.linkBack = '/admin/home-support-sujet/support-sujet-not-connected'
      } else {
        this.linkBack = '/admin/home-support-sujet/support-sujet-connected'
      }

      console.info('linkBack : ' + this.linkBack);

    });

    this.messageService.sendMessage('support-sujet-detail');

    if(this.supportSujetRequested) {
      console.log("update sujet " + this.supportSujetRequested);
      this.title = "Modification sujet";

      this.supportSujetService.getSupportSujetById(this.supportSujetRequested)
      .subscribe(
          response => {
            let responseData = response.body;
            this.alertService.clear();            

            let entity: SupportSujet = {
              key: responseData.key,
              sujet : responseData.sujet,
              emailDestinataire : responseData.emailDestinataire,
              nomDestinataire : responseData.nomDestinataire,
              actif: responseData.actif,
              publique: responseData.publique,
              ordreTri: responseData.ordreTri
            }

            this.setForm(entity);
            this.editMode = true;
            this.current = entity;
            this.supportSujetPublique = entity.publique;
          },
          error => {
            console.error(error)
          });
    } else {
      console.log("add user");
    }

    this.supportSujetForm = this.formBuilder.group({
      sujet : ['', [Validators.required]],
      emailDestinataire: ['', [Validators.required, 
        Validators.minLength(5), 
        Validators.maxLength(256),
        Validators.email]],
      nomDestinataire : ['', [Validators.required,
        Validators.pattern(regExps.onlyLettersAccent)]],
      actif: [{value: 'true'} ],
      ordreTri: [ '', [Validators.pattern(regExps.onlyDigits)] ]
    });
  }

  private setForm(entity: SupportSujet) {
    this.supportSujetForm.patchValue(
      {
        key : entity.key,
        sujet: entity.sujet,
        emailDestinataire : entity.emailDestinataire,
        nomDestinataire : entity.nomDestinataire,
        actif: entity.actif
        //publique: entity.publique,
        //ordreTri: entity.ordreTri
     });    
  }

  onFormSubmit(form: FormGroup) {
    this.submitted = true;

    // stop here if form is invalid
    if (this.supportSujetForm.invalid) {
      console.log(this.supportSujetForm.errors)
      return;
    }

    console.log('sujet actif ' + form.controls.actif.value);

    if(this.editMode) {
      let direction = form.controls.ordreTri.value > this.current.ordreTri ? 'down' : 'up';
      const supportSujetUpdate: SupportSujetUpdateRequest = {
        sujet: form.controls.sujet.value,
        emailDestinataire: form.controls.emailDestinataire.value,
        nomDestinataire: form.controls.nomDestinataire.value,
        actif: form.controls.actif ? form.controls.actif.value : true,
        publique: this.supportSujetPublique,
        ordreTri: this.current.ordreTri
      };
      console.log(supportSujetUpdate);
      this.updateSupportSujet(this.current.key, supportSujetUpdate, direction);
    } else {
      const supportSujet: SupportSujetRequest = {
        sujet: form.controls.sujet.value,
        emailDestinataire: form.controls.emailDestinataire.value,
        nomDestinataire: form.controls.nomDestinataire.value,
        actif: form.controls.actif ? form.controls.actif.value.value : true,
        publique: this.supportSujetPublique,
        ordreTri: form.controls.ordreTri.value,
      };
      this.createSupportSujet(supportSujet);

    }
  }

  createSupportSujet(supportSujet: SupportSujetRequest) {
    this.supportSujetService.add(supportSujet)
    .subscribe(
        response => {
          this.alertService.success('Utilisateur crée', true);
          this._router.navigate([this.linkBack], { queryParams: { typeSupportSujet: this.typeSupportSujet }});
          },
        error => {
          console.log(error);
          this.alertService.error(error);
        });
  }

  updateSupportSujet(supportSujetKey: number, supportSujetUpdate: SupportSujetUpdateRequest, direction: string) {
    this.supportSujetService.update(supportSujetKey, supportSujetUpdate, direction)
    .subscribe(
        response => {
          let serverResponse = response.body;
          this.alertService.success('Modifications enregistrées', true);
          this._router.navigate([this.linkBack], { queryParams: { typeSupportSujet: this.typeSupportSujet }});
        },
        error => {
          console.log(error);
          this.alertService.error(error);
        });
  }

}
